import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { patch } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "locations";

export const editParticularLocation = async (payload: any) => {
	try {
		const endpoint = `${initialRoute}/edit-location`;
		const token = localStorage.getItem("@jwt");

		const response = await patch(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		// console.log("response => ", response);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === "Data edited successfully") {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
